import React, { useEffect, useState } from 'react';
import { HashIcon } from 'lucide-react';
import { GlassCard } from './GlassCard';
import { CircularGauge } from './CircularGauge';
import { motion } from 'framer-motion';
const messages = [{
  user: 'Alex Chen',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150',
  message: 'I might be wrong, but I think we should consider a different approach to the user onboarding flow',
  time: '10:30 AM'
}, {
  user: 'Sarah Miller',
  avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&q=80&w=150',
  message: "Great question, Alex! Let's dig into that. What specifically made you think about changing it?",
  time: '10:32 AM'
}, {
  user: 'Marcus Wong',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=150',
  message: "I've noticed similar patterns in our user feedback sessions. The initial step seems to be causing some confusion.",
  time: '10:33 AM'
}, {
  user: 'Emily Zhang',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150',
  message: '💡 What if we added interactive tooltips to guide users through each step?',
  time: '10:34 AM'
}, {
  user: 'Alex Chen',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150',
  message: 'Thanks everyone! The analytics show a 40% drop-off at the connection screen specifically',
  time: '10:35 AM'
}, {
  user: 'David Kim',
  avatar: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?auto=format&fit=crop&q=80&w=150',
  message: 'I can help prototype some solutions. Already have a few ideas based on our previous A/B tests 🛠️',
  time: '10:36 AM'
}, {
  user: 'Sarah Miller',
  avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&q=80&w=150',
  message: "Love the collaborative energy here! Let's set up a quick design sprint to tackle this 🚀",
  time: '10:37 AM'
}];
export const SlackThreadBackground = () => {
  const [isInView, setIsInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
      }
    }, {
      threshold: 0.5
    });
    const element = document.querySelector('.slack-thread-container');
    if (element) {
      observer.observe(element);
    }
    return () => observer.disconnect();
  }, []);
  return <div className="w-full h-full bg-white relative slack-thread-container" data-id="element-227">
      {/* Channel Header */}
      <motion.div className="bg-gray-50 border-b border-gray-200 px-4 py-2 flex items-center" animate={{
      opacity: isInView ? 0 : 1
    }} transition={{
      duration: 0.5,
      delay: 0.35,
      ease: 'easeOut'
    }} data-id="element-228">
        <HashIcon size={18} className="text-gray-500 mr-2" data-id="element-229" />
        <span className="text-gray-800 font-medium" data-id="element-230">team-product</span>
        <span className="ml-2 text-gray-500 text-sm" data-id="element-231">15 members</span>
      </motion.div>
      {/* Messages Container */}
      <motion.div className="p-4 space-y-4" style={{
      filter: 'blur(1.5px) saturate(0.7)'
    }} animate={{
      y: isInView ? [-400, -800] : 0
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'linear',
      repeatType: 'loop'
    }} data-id="element-232">
        {[...messages, ...messages, ...messages].map((msg, index) => <div key={index} className="flex items-start" data-id="element-233">
            <img src={msg.avatar} alt={msg.user} className="w-8 h-8 rounded mr-3" data-id="element-234" />
            <div data-id="element-235">
              <div className="flex items-baseline" data-id="element-236">
                <span className="font-bold text-gray-900 mr-2" data-id="element-237">{msg.user}</span>
                <span className="text-xs text-gray-500" data-id="element-238">{msg.time}</span>
              </div>
              <p className="text-gray-800 mt-1" data-id="element-239">{msg.message}</p>
            </div>
          </div>)}
      </motion.div>
      {/* Glass Card Overlay */}
      <motion.div className="absolute top-1/2 left-1/2" style={{
      x: '-50%',
      y: '-50%'
    }} initial={{
      opacity: 0,
      y: 'calc(-50% + 20px)'
    }} animate={{
      opacity: isInView ? 1 : 0,
      y: isInView ? '-50%' : 'calc(-50% + 20px)'
    }} transition={{
      duration: 0.35,
      ease: [0.25, 0.46, 0.45, 0.94]
    }} data-id="element-240">
        <GlassCard isInView={isInView} title="Psych Safety" data-id="element-241" />
      </motion.div>
    </div>;
};